import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {

  interface TypographyVariants {
    landingPageHeader1: React.CSSProperties;
    body3: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    landingPageHeader1?: React.CSSProperties;
    body3?: React.CSSProperties;
  }

  interface Palette {
    custom: {
      orange: string;
      darkOrange: string;
      veryLightOrange: string;
      lightGrey: string;
      darkGrey: string;
      green: string;
      darkgreen: string;
      red: string;
      lightblue: string;
      yellow: string;
      amber: string;
      beige: string;
      beigeDarkContrast: string;
      beigeLightContrast: string;
    };
  }

  interface PaletteOptions {
    custom?: {
      orange: string;
      darkOrange: string;
      veryLightOrange: string;
      lightGrey: string;
      darkGrey: string;
      green: string;
      darkgreen: string;
      red: string;
      lightblue: string;
      yellow: string;
      amber: string;
      beige: string;
      beigeDarkContrast: string;
      beigeLightContrast: string;
    };
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    landingPageHeader1: true;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#f16522', // My orange
      dark: '#d1551c',
    },
    secondary: {
      main: '#007bff', // My blue
      dark: '#0056b3',
    },
    custom: {
      orange: '#f16522', //Not used - instead do primary.main
      darkOrange: '#d1551c', //Not used - instead use primary.dark
      veryLightOrange: 'rgba(241, 101, 34, 0.08)', //used for selected answer in DiagnosticTest.tsx
      lightGrey: '#e0e0e0',
      darkGrey: '#2e2e2e',
      green: '#4caf50',
      darkgreen: '#388e3c',
      red: '#f44336', //or #fd7272 for a light red, almost pink which doesn't feel so punishing
      lightblue: '#63d5fe',
      yellow: '#f9f919',
      amber: "#FFA000", // Added amber color for better visibility
      beige: "#f7f5f0",
      beigeDarkContrast: 'rgba(255, 224, 178, 0.35)', // Amber tint at low opacity
      beigeLightContrast: '#f9f9f7'
    },
    background: {
      default: '#ffffff',
      paper: '#f9f9f9',
    },
    text: {
      primary: '#0A0A0A',
    }
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
    //Previous font settings before 5/14/2025:
    //fontFamily: '"Helvetica Neue", Arial, sans-serif',
    landingPageHeader1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      fontFamily: '"Libre Baskerville", serif',
      color: '#f16522',
    },
    h1: {
      fontSize: '2.5rem',
      //fontWeight: 500,
      color: '#f16522'
    },
    h4: {
      color: '#f16522',
    },
    h5: {
      color: '#f16522',
    },
    h6: {
      color: '#f16522',
    },
    body1: {
      fontSize: '1.125rem',       // 16px - your main body text
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',   // 14px - secondary text
      lineHeight: 1.43,
    },
    body3: {
      fontSize: '0.75rem',
      lineHeight: 1.43,
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          textTransform: 'none', // Prevents automatic uppercase
        },
        contained: {
          backgroundColor: '#f16522',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d1551c',
            transform: 'scale(1.02)',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          },
        },
        outlined: {
            backbroundColor: 'f9f9f9',
            color: '#0A0A0A',
            '&:hover': {
                backgroundColor: 'f0f0f0',
                transform: 'scale(1.02)',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            },
            border: '1px solid #ddd',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
        }
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        },
      },
    }
  },
});

export default theme;